import { render, staticRenderFns } from "./editDeparyment.vue?vue&type=template&id=6e252d63"
import script from "./editDeparyment.vue?vue&type=script&lang=js"
export * from "./editDeparyment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports